import clsx from "clsx";
import React from "react";

interface ToggleProps {
	choicesNumberToToggle: number;
	choicesCollapsed: boolean;
	onToggle: React.ReactEventHandler<HTMLButtonElement>;
}

export function Toggle({
	choicesNumberToToggle,
	choicesCollapsed,
	onToggle,
}: ToggleProps) {
	const classes = clsx("choices-toggle tag tag-transparent", {
		"choices-toggle--expand": choicesCollapsed,
	});

	return (
		<li className={classes}>
			<button type="button" onClick={onToggle}>
				{`Show ${choicesCollapsed ? `${choicesNumberToToggle} more` : "less"}`}
			</button>
		</li>
	);
}
